import { ModalContainer } from '@welbe/web-design-system';
import { Button } from '@welbe/design-system';
import { useEffect, useState } from 'react';
import {
	ActionContainer,
	Carousel,
	Description,
	Dot,
	DotContainer,
	ImageContainer,
	Slides,
	SlideshowContainer,
	SubtitleCard,
	TitleCard,
} from './IntroTutorial.styles';

import { ContextLog } from 'constants/contextLog';
import { getPreference, setPreference } from 'db';
import Analytics from 'helpers/analytics';
import { useAnalyticsOpenScreen } from 'hooks/useAnalyticsOpenScreen';
import { useSessionStorage } from 'hooks/useSessionStorage';

interface IIntroTutorialProps {
	items: any;
	height: string;
	context: ContextLog;
	onFinish: () => void;
}

export const IntroTutorial = ({
	context,
	height,
	items,
	onFinish,
}: IIntroTutorialProps): JSX.Element => {
	const { getSessionStorage } = useSessionStorage();
	const [visible, setVisible] = useState(false);
	const [currentUserId, setCurrentUserId] = useState('');
	const [currentSlide, setCurrentSlide] = useState(0);

	const handleNext = (index: number) => {
		setCurrentSlide(index);
		Analytics.track(context, `change-slide-new-${context}-carousel`, {
			slideNumber: index,
			description: `Change to slide ${index + 1} carousel new ${context}`,
		});
	};

	const handleFinish = () => {
		onFinish();
		setPreference(currentUserId, true);
		Analytics.track(context, `end-new-${context}-carousel`, {
			descriptiion: 'Ending new ${context} carousel',
		});
	};

	const handleHide = () => {
		onFinish();
		setPreference(currentUserId, true);
		Analytics.track(context, `hide-new-${context}-carousel`, {
			descriptiion: `Hide new ${context} carousel`,
		});
	};

	useAnalyticsOpenScreen({
		context: context,
		trackName: `Start tour ${context}`,
	});

	useEffect(() => {
		const user = JSON.parse(getSessionStorage('me') || '{ id: "" }');
		getPreference(user.id).then((preference) => {
			preference ? handleFinish() : setVisible(true);
		});
		setCurrentUserId(user.id);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (!visible) return <></>;

	return (
		<ModalContainer
			closeOnlyOnTheButton
			visible={visible}
			width="530px"
			height={height}
			borderRadius="6px"
		>
			<Carousel>
				<SlideshowContainer>
					{items.map((item: any, index: number) => (
						<Slides key={index} active={currentSlide === index}>
							<TitleCard>
								<p>{item.title}</p>
							</TitleCard>
							{item.subtitle && <SubtitleCard>{item.subtitle}</SubtitleCard>}
							<ImageContainer hasSubtitle={!!item.subtitle}>
								<img
									src={item.img.src}
									width={item.img.width}
									height={item.img.height}
								/>
							</ImageContainer>
							<Description>{item.description}</Description>
						</Slides>
					))}
				</SlideshowContainer>

				<DotContainer>
					{items.map((_: any, index: number) => (
						<Dot key={index} className="dot" active={currentSlide === index} />
					))}
				</DotContainer>

				<ActionContainer>
					{currentSlide !== 4 && (
						<Button width="130px" variant="outline" onClick={handleHide}>
							Omitir
						</Button>
					)}
					<Button
						width="130px"
						onClick={() => {
							currentSlide === items.length - 1
								? handleFinish()
								: handleNext(currentSlide + 1);
						}}
					>
						{currentSlide === items.length - 1 ? 'Comenzar' : 'Siguiente'}
					</Button>
				</ActionContainer>
			</Carousel>
		</ModalContainer>
	);
};
